module.exports = __webpack_public_path__ + "img/5-2.ca261d6d.jpg";